<template>
  <b-card no-body class="p-2">
    <h3 class="mb-2">
      {{
        jobLinePosition.puestoLineaAscensoId == 0
          ? $t("Routes.JobLinePositionAdd")
          : $t("Routes.JobLinePositionEdit")
      }}
    </h3>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.jobLinePosition.columns.job')"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.jobLinePosition.columns.job')"
                :state="errors.length > 0 ? false : null"
              >
                <v-select
                  id="Puesto"
                  v-model="jobLinePosition.puestoId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="nombre"
                  :options="jobs"
                  :reduce="(option) => option.puestoId"
                  @search="searchJobs"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.jobLinePosition.columns.order')"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.jobLinePosition.columns.order')"
                :state="errors.length > 0 ? false : null"
              >
                <b-form-input
                  v-model="jobLinePosition.orden"
                  type="number"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-checkbox
              id="checkbox-1"
              v-model="jobLinePosition.delArea"
              name="fromArea"
              :value="true"
              :unchecked-value="false"
            >
              {{ $t('humanResources.jobLinePosition.columns.fromArea') }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="float-right mt-2 mb-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            <b-spinner v-if="addingJobLinePosition" small class="mr-1" />
            {{ jobLinePosition.puestoLineaAscensoId == 0 ? $t("Lists.Add") : $t("Lists.Edit") }}
          </b-button>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BSpinner,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import humanResources from '@/services/humanresources.service'
import optionService from '@/services/option.service'
import vSelect from 'vue-select'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@validations'
import router from '@/router'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInvalidFeedback,
    BFormGroup,
    BButton,
    BFormInput,
    BSpinner,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,

    vSelect,
  },
  setup() {
    const jobs = ref([])
    const schedules = ref([])
    const addingJobLinePosition = ref(false)
    const jobLinePosition = ref({
      puestoLineaAscensoId: 0,
      puestoId: 0,
      delArea: false,
      orden: null,
    })

    const blankJobLinePosition = {
      puestoLineaAscensoId: 0,
      puestoId: 0,
      delArea: false,
      orden: null,
    }

    const {
      fetchJobLinePosition,
      createJobLinePosition,
      updateJobLinePosition,
      fetchJobs,
    } = humanResources()

    const {
      fetchOptions,
    } = optionService()

    const resetJobLinePosition = () => {
      jobLinePosition.value = JSON.parse(JSON.stringify(blankJobLinePosition))
    }

    if (router.currentRoute.params.puestoLineaAscensoId) {
      fetchJobLinePosition(router.currentRoute.params.puestoLineaAscensoId, data => {
        jobLinePosition.value = data
      })
    } else {
      jobLinePosition.value = JSON.parse(JSON.stringify(blankJobLinePosition))
    }
    fetchOptions({ nombreDominio: 'RecursosHumanosHorario' }, data => {
      schedules.value = data
    })
    const searchJobs = text => {
      fetchJobs({ searchQuery: text, limit: 50 }, data => {
        jobs.value = data.puestos
      })
    }
    fetchJobs({ limit: 50 }, data => {
      jobs.value = data.puestos
    })
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetJobLinePosition)

    const onSubmit = () => {
      addingJobLinePosition.value = true
      if (jobLinePosition.value.puestoLineaAscensoId === 0) {
        createJobLinePosition(jobLinePosition.value, () => {
          addingJobLinePosition.value = false
          router.push({ name: 'apps-human-resources-job-line-position-list' })
        })
      } else {
        updateJobLinePosition(jobLinePosition.value.puestoLineaAscensoId, jobLinePosition.value, () => {
          addingJobLinePosition.value = false
          router.push({ name: 'apps-human-resources-job-line-position-list' })
        })
      }
    }

    return {
      jobs,
      schedules,
      jobLinePosition,
      addingJobLinePosition,
      required,
      getValidationState,
      refFormObserver,
      resetForm,
      onSubmit,
      searchJobs,

    }
  },
}
</script>
